import axios from 'axios';
import Cookies from 'js-cookie';

export const userService = {
    login,
    register,
    logout,
    user,
    forgotPasswordSendMail,
    forgotPasswordVerifyOtp,
    newPassword,
    registerVerificationOtp,
    resendOtp,
};

function user() {
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + Cookies.get('EAPISID'),
        },
    });
    return requestOptions
        .get('me')
        .then(handleUserResponse)
        .catch((error) => error.response);
}

function handleUserResponse(response) {
    return response;
}

function login(email, password) {
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: { 'Content-Type': 'application/json' },
    });

    return requestOptions
        .post('/auth/login', JSON.stringify({ email, password }))
        .then(handleResponse)
        .catch((error) => {
            if (error.response.status === 401) {
                logout();
                return error.response;
            } else if (error.response.status === 403) {
                return error.response;
            }

            return error.response.data;
        });
}

function register(payload, type) {
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: { 'Content-Type': 'application/json' },
    });
    return requestOptions.post(`/auth/register?type=${type}`, JSON.stringify(payload)).catch((error) => {
        let errorMessage = error.response?.data?.message || 'An unexpected error occurred. Please try again.';
        const status = error.response?.status;

        switch (status) {
            case 409:
                errorMessage = error.response?.data?.message || 'The email has already been taken.';
                break;
            case 400:
                errorMessage = error.response?.data?.message || 'Invalid registration data. Please check your inputs.';
                break;
            case 422:
                errorMessage =
                    error.response?.data?.message || 'Please check your email format and password requirements.';
                break;
            default:
                errorMessage = error.response?.data?.message || 'An unexpected error occurred. Please try again.';
                break;
        }

        throw new Error(errorMessage);
    });
}

function forgotPasswordSendMail(email) {
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: { 'Content-Type': 'application/json' },
    });

    return requestOptions
        .post('auth/forgot', { email: email })
        .then(handleRegisterResponse)
        .catch((error) => {
            // console.log(error);
        });
}

function forgotPasswordVerifyOtp(email, otp) {
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return requestOptions
        .post('auth/forgotVerifyOtp', { email: email, otp: otp })
        .then(handleRegisterResponse)
        .catch((error) => {
            // console.log(error);
        });
}

function registerVerificationOtp(email, otp) {
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return requestOptions
        .post('auth/otpVerify', { email: email, otp: otp })
        .then((res) => res)
        .catch((error) => {
            let errorMessage = error.response?.data?.message || 'An unexpected error occurred. Please try again.';
            const status = error.response?.status;

            switch (status) {
                case 400 || 401:
                    errorMessage = error.response?.data?.message || 'Invalid OTP. Please check and try again.';
                    break;
                case 429:
                    errorMessage = error.response?.data?.message || 'Too many attempts. Please try again later.';
                    break;
                default:
                    errorMessage = error.response?.data?.message || 'An unexpected error occurred. Please try again.';
                    break;
            }

            throw new Error(errorMessage);
        });
}

function newPassword(email, password, cpassword) {
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + Cookies.get('tempAUTH&TOKEN'),
        },
    });

    return requestOptions
        .post('auth/forgotNewPassword', {
            email: email,
            new_password: password,
            confirm_password: cpassword,
        })
        .then(handleResponse)
        .catch((error) => {
            // console.log(error);
        });
}

function handleResponse(response) {
    // store access token in cookie to keep user logged in between page refreshes
    let user = response.data.data;
    if (user.token) {
        Cookies.set('EAPISID', user.token, { expires: 180, path: '/' });
        Cookies.set('auth', user.user.auth_id);
        Cookies.remove('tempAUTH&TOKEN');
    }
    return response;
}

function handleRegisterResponse(response) {
    // store access token in cookie to keep user logged in between page refreshes
    let user = response.data.data;
    if (user.token) {
        Cookies.set('tempAUTH&TOKEN', user.token, { expires: 180, path: '/' });
    }
    return response;
}

function logout() {
    // remove user from local storage to log user out
    Cookies.remove('EAPISID');
    Cookies.remove('auth');
}

function resendOtp(email) {
    console.log('----called----- resendOtp services');
    const requestOptions = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: { 'Content-Type': 'application/json' },
    });
    return requestOptions
        .post('/auth/forgot', { email: email, resend: true })
        .then((response) => response)
        .catch((error) => {
            // console.log(error);
        });
}
